<template>
  <div>
    <h4 class="" style="font-weight: 500; margin-bottom: 0;">Service Schedule</h4>
    <hr>
    <h5 class="mt-3" style="margin-bottom: 0;">Sunday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(sundayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(sundayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="sundayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Monday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(mondayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(mondayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="mondayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Tuesday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(tuesdayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(tuesdayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="tuesdayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Wednesday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(wednesdayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(wednesdayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="wednesdayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Thursday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(thursdayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(thursdayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="thursdayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Friday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(fridayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(fridayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="fridayRange" :enable-cross="false"></vue-slider>
    <h5 class="mt-3" style="margin-bottom: 0;">Saturday</h5>
    <label style="width: 100%; margin-bottom: 0;">Start Time: {{ djangotimeformatAMPM(saturdayRange[0]) }}<span style="float: right">End Time: {{ djangotimeformatAMPM(saturdayRange[1]) }}</span></label>
    <vue-slider :data="timeOptions" v-model="saturdayRange" :enable-cross="false"></vue-slider>
    <hr>
    <button class="mylisting-button dark-button mt-1" @click="updateSchedule()">Update Schedule</button>

    <modal name="schedule-updated-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Schedule updated.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('schedule-updated-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

// https://nightcatsama.github.io/vue-slider-component/#/
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  props: ['user'],
  components: {
    VueSlider,
  },
  data() {
    return {
      // showDate: new Date(),
      // selectedDate: null,
      // schedule: ['HH', 'MM', 'HH', 'MM', 'HH', 'MM', 'HH', 'MM'],
      // days: [],
      // schedule: [],
      // day: {},
      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // minuteOptions: ['00', '30'],
      // sundayRange: ['00:30', '01:30'],
      sundayRange: ['00:00', '00:00'],
      mondayRange: ['00:00', '00:00'],
      tuesdayRange: ['00:00', '00:00'],
      wednesdayRange: ['00:00', '00:00'],
      thursdayRange: ['00:00', '00:00'],
      fridayRange: ['00:00', '00:00'],
      saturdayRange: ['00:00', '00:00'],
      // mondayStart: '00:30',
      // mondayEnd: '01:30',
      timeOptions: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'],
      // timeStatuses: ['Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable', 'Unavailable'],
      // availableTimes: [],
      // selectedTimes: [],
      // events: [],
    }
  },
  created() {
    // this.schedule = this.listing.multiselect1
    if (this.user.preferences2.length) {
      this.schedule = this.user.preferences2
    }
    else {
      this.schedule = ['00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00', '00:00']
    }
    this.sundayRange = this.schedule.slice(0,2)
    this.mondayRange = this.schedule.slice(2,4)
    this.tuesdayRange = this.schedule.slice(4,6)
    this.wednesdayRange = this.schedule.slice(6,8)
    this.thursdayRange = this.schedule.slice(8,10)
    this.fridayRange = this.schedule.slice(10,12)
    this.saturdayRange = this.schedule.slice(12,14)
  },
  methods: {
    updateSchedule() {
      this.schedule[0] = this.sundayRange[0]
      this.schedule[1] = this.sundayRange[1]
      this.schedule[2] = this.mondayRange[0]
      this.schedule[3] = this.mondayRange[1]
      this.schedule[4] = this.tuesdayRange[0]
      this.schedule[5] = this.tuesdayRange[1]
      this.schedule[6] = this.wednesdayRange[0]
      this.schedule[7] = this.wednesdayRange[1]
      this.schedule[8] = this.thursdayRange[0]
      this.schedule[9] = this.thursdayRange[1]
      this.schedule[10] = this.fridayRange[0]
      this.schedule[11] = this.fridayRange[1]
      this.schedule[12] = this.saturdayRange[0]
      this.schedule[13] = this.saturdayRange[1]
      console.log(this.schedule)

      axios.patch('/api/people/'+this.user.id+'/', {
        preferences2: this.schedule
      })
        .then(res => {
          console.log(res)
          this.$modal.show('schedule-updated-modal')
          // this.listing.multiselect1 = this.schedule
          console.log(this.schedule)
        })
        .catch(error => {console.log(error)})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/jobs/WeekScheduler.vue